import $axios from "./request-account";
/* 联系人模块 */

//公共oWner联系人相互关联
export const contactsOwner = (data) => {
  return $axios.post("/client/v2/api/combination/contact/list", data);
};
//获取登录信息
export const getUserIdInt = (data) => {
  return $axios.post("/client/v2/api/contacts/getUserIdInt", data);
};

//获取联系人列表数据
export const contactsList = (data) => {
  return $axios.post("/client/v2/api/contacts/list", data);
};
//通过id查详情
export const contactsDetails = (data) => {
  return $axios.post("/client/v2/api/contacts/details", data);
};
//新建联系人
export const createContacts = (data) => {
  return $axios.post("/client/v2/api/create/contacts", data);
};
//编辑联系人
export const editContacts = (data) => {
  return $axios.post("/client/v2/api/edit/contacts", data);
};
//删除联系人
export const deleteContacts = (data) => {
  return $axios.post("/client/v2/api/del/contacts", data);
};
//分配联系人
export const distributionContact = (data) => {
  return $axios.post("/client/v2/api/distribution/contact", data);
};
//分配联系人列表
export const distributionList = (data) => {
  return $axios.post("/client/v2/api/distribution/contact/list", data);
};
//删除分配联系人
export const distributionDel = (data) => {
  return $axios.post("/client/v2/api/distribution/contact/del", data);
};

//供应商列表数据
export const vendorsList = (data) => {
  return $axios.post("/client/v2/api/vendors/list", data);
};
//通过id查供应商详情
export const vendorsDetails = (data) => {
  return $axios.post("/client/v2/api/vendors/details", data);
};
//新建供应商
export const createVendors = (data) => {
  return $axios.post("/client/v2/api/create/vendors", data);
};
//编辑供应商
export const editVendors = (data) => {
  return $axios.post("/client/v2/api/edit/vendors", data);
};
//删除供应商
export const deleteVendors = (data) => {
  return $axios.post("/client/v2/api/vendors/del", data);
};

/* 下拉框数据 */
//角色国家下的联系人
export const lowerUserList = (data) => {
  return $axios.post("/client/v2/api/user/country/YYcontacts", data);
};
//供应商客户树
export const vendoruserList = (data) => {
  return $axios.post("/client/v2/api/nav/user/list", data);
};
//角色下的联系人-->左上角
export const topUserList = (data) => {
  return $axios.post("/client/v2/api/top/user/YYlist", data);
};
//默认供应商
export const vendorList = (data) => {
  return $axios.post("/client/v2/api/vendor/list", data);
};

//联系人公共询盘利润率单个设置
export const setProfitSingle = (data) => {
  return $axios.post("/client/v2/api/contacts/setProfitSingle", data);
};

//联系人公共询盘利润率批量设置
export const setProfitBatch = (data) => {
  return $axios.post("/client/v2/api/contacts/setProfitBatch", data);
};

/* 重构后的联系人 */
export const getYYcontactsNew = (data) => {
  return $axios.post("/client/v2/api/user/country/oneLevelOwner", data);
};
/* 重构后的联系人 */
export const getContactByOwner = (data) => {
  return $axios.post("/client/v2/api/user/country/twoLevelCountry", data);
};
/* 重构后的联系人 */
export const threeLevelContact = (data) => {
  return $axios.post("/client/v2/api/user/country/threeLevelContact", data);
};

//组织下的Owner列表
export const getOwnerList = (data) => {
  return $axios.post("/client/v2/api/contact/owner/list", data);
};
//组织下的联系人列表
export const institutionalOwnerList = (data) => {
  return $axios.post("/client/v2/api/owner/contact/list", data);
};